import type { FaireProductEntity } from "../../entity_types/product";

export const p_dmn22zbbrg: FaireProductEntity = {
  token: "p_dmn22zbbrg",
  type: "product",
  name: "Ember Contrast Color V Neckline Knit Cardigan",
  brandToken: "b_32jxh7lm9h",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/b2ee21c1958f84ac0f6d1dce1a2a7b4d40ed82ef9991cb50a99aa896cb7a23f8.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f5b23aba827265c4a6d9a3a7e51337747d3e5fc3000c242916818c953ae10b90.png",
    "https://cdn.faire.com/fastly/9c02eadffd704800d2cc8f5d013d85a5499e6ff76b4b6f96758e8e753ed1ec7b.png",
    "https://cdn.faire.com/fastly/890c1dc42db78ce4424eb25c3c0e59879aea6da30e7373c8ca458e5abac0bd45.jpeg",
    "https://cdn.faire.com/fastly/4baa7fb7594814bc6e54b6e8e0d1c070aa5b5d535f7243d796aa12bbb9b62469.jpeg",
    "https://cdn.faire.com/fastly/cbd544d2f764a9367c65ad9a825b476a1c0cb76ed5d5a81b62cda98ee57ee469.jpeg",
    "https://cdn.faire.com/fastly/a5de1504a28b0a40cd55f58c25f5a2101922f15b6fc1ed95d400687105bf8034.jpeg",
    "https://cdn.faire.com/fastly/2926a35671d4dc9da23b61d1edcab1b4e31f13066304b648ecac3224698bf201.jpeg",
    "https://cdn.faire.com/fastly/a57cb395a5277577a8934c691fc91a3c4d5dd0ba7dc019dabbd42258687286e8.jpeg",
    "https://cdn.faire.com/fastly/72a9895653cd036a389b21c5c6d7bdad06dac01ed1c17d7c2a0a07151b1ce933.png",
    "https://cdn.faire.com/fastly/665d86ed69eb5d7146d694e688032307a15cdf8cba1751e6fe3fe6b22440706d.webp",
    "https://cdn.faire.com/fastly/78c550528ecfb10c997b3e47bcd225f1f70ff12b26771b045500c368b8976d3f.webp",
    "https://cdn.faire.com/fastly/45e459a56143c577991835db45d3aa6a4e033f77e170e4ba022f144d14cb35f5.png",
    "https://cdn.faire.com/fastly/06059e0af3b6d611421dff12464d2f1596899415db7550137577205ba0b2dd57.jpeg",
    "https://cdn.faire.com/fastly/e089d536e9a1b040dd68e414edbfd3c6bb8a8ff29a111932fd054398e44f1b75.jpeg",
    "https://cdn.faire.com/fastly/a75edd90bdd3cca364273daf3f8206f0deddbee86ca56077f4021cb3e6b356ff.jpeg",
    "https://cdn.faire.com/fastly/c96a047c03c3dde71c530e301359f3161f4d84d6b1a997bd93f59a63c6634ff4.jpeg",
    "https://cdn.faire.com/fastly/51319a0c57496617b51ddb152e8c3e6795c82854669baeee9bd47951f918fc24.jpeg",
    "https://cdn.faire.com/fastly/8a99974124570d808b22c142baed7f24f9fcde45f508cad18b9e5347806b4d28.jpeg",
    "https://cdn.faire.com/fastly/7f50a7da18012b599ae7b12aedf9a29222de27e15bfb722704018faba0afd8a5.jpeg",
    "https://cdn.faire.com/fastly/71fc19a0831b0d0714cabacd380831a34958077625323a2446a5814838672d79.jpeg",
    "https://cdn.faire.com/fastly/c570108debcac4b0101376cd0b39540391da261d55d19e93dc27720efb2e684f.jpeg",
    "https://cdn.faire.com/fastly/10ae8cd530c5e38e484c51c5e5c74fbbcaf53a33dd02ab74f36bd79896ae467a.jpeg",
  ],
  priceDollars: 39.5,
  description:
    "Material:100%Acrylic\n\n * Rich chestnut color with striking contrast binding adds a touch of sophistication to any outfit. \n * Stylish button details enhance the V neckline, creating a versatile and chic look for various occasions. \n * Comfortable raglan sleeves provide a relaxed fit and allow for easy movement throughout the day. \n * The long sleeves offer warmth and coziness, perfect for layering during cooler seasons. \n Size Chart (CM)\n\n\n\n\nSizes\n\n\n\nUS Sizes\n\n\n\nEuro Sizes\n\n\n\nUK Sizes\n\n\n\nBust\n\n\n\nHem Width\n\n\n\nSleeve Length\n\n\n\nLength\n\n\n\n\nRelax\n\n\n\nRelax\n\n\n\nRelax\n\n\n\nRelax\n\n\n\n\nS\n\n\n\n4-6\n\n\n\n34-36\n\n\n\n8-10\n\n\n\n90.0\n\n\n\n88.0\n\n\n\n67.5\n\n\n\n50.0\n\n\n\n\nM\n\n\n\n8-10\n\n\n\n38-40\n\n\n\n12-14\n\n\n\n96.0\n\n\n\n94.0\n\n\n\n69.0\n\n\n\n52.0\n\n\n\n\nL\n\n\n\n12-14\n\n\n\n42-44\n\n\n\n16-18\n\n\n\n102.0",
  tags: [],
  msrpDollars: 79,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:27.978Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
